import { render, staticRenderFns } from "./ScrollModule.vue?vue&type=template&id=25c15f4a&scoped=true"
import script from "./ScrollModule.vue?vue&type=script&lang=js"
export * from "./ScrollModule.vue?vue&type=script&lang=js"
import style0 from "./ScrollModule.vue?vue&type=style&index=0&id=25c15f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c15f4a",
  null
  
)

export default component.exports